<template>
  <div class="pw-reset">
    <div class="box mt-4">
      <h1 class="title is-5">{{ $t('account.password-reset') }}</h1>
      <b-message type="is-success" has-icon v-if="successFullChanged">
        {{ $t('notices.reset-password-success') }}
      </b-message>
      <b-message type="is-danger" has-icon v-if="errors && errors.length > 0">
        <ul>
          <li v-for="(e, i) in errors" :key="i">{{ e.value }}</li>
        </ul>
      </b-message>
      <div v-if="!successFullChanged">
        <ValidationObserver v-slot="{invalid}">
          <form>
            <ValidationProvider name="E-Mail" :rules="{required: true, email: true}" v-slot="{errors}" class="mb-3 is-block">
              <b-field :label="$t('general.email')">
                <b-input type="text" v-model="email"></b-input>
                <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
              </b-field>
            </ValidationProvider>
            <ValidationProvider name="Schlüssel" :rules="{required: true}" v-slot="{errors}" class="mb-3 is-block">
              <b-field :label="$t('general.key')">
                <b-input type="text" v-model="token"></b-input>
                <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
              </b-field>
            </ValidationProvider>
            <ValidationProvider name="neues Passwort" :rules="{required: true, min: 6, confirmed: 'confirmation'}" v-slot="{errors}" class="mb-3 is-block">
              <b-field :label="$t('account.new-passowrd')">
                <b-input type="password" v-model="newPassword" password-reveal></b-input>
                <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
              </b-field>
            </ValidationProvider>
            <ValidationProvider name="neues Passwort wiederholen" vid="confirmation" :rules="{required: true, min: 6}" v-slot="{errors}" class="mb-4 is-block">
              <b-field :label="`${$t('account.new-passowrd')} ${$t('general.retry')}`">
                <b-input type="password" v-model="passwordVerify" password-reveal></b-input>
                <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
              </b-field>
            </ValidationProvider>
            <b-button type="is-primary" size="is-medium" :disabled="invalid" @click="change" expanded>{{ $t('general.reset') }}</b-button>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordReset',
  data() {
    return {
      token: '',
      email: '',
      newPassword: '',
      passwordVerify: '',
      successFullChanged: false,
      errors: [],
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.t) {
      this.token = this.$route.query.t
    }
    if (this.$route.query && this.$route.query.m) {
      this.email = this.$route.query.m
    }
  },
  methods: {
    async change() {
      this.errors = []

      this.successFullChanged = false
      let res = await this.$store.dispatch('$_account/resetPassword', {email: this.email, token: this.token, password: this.newPassword})
      if (res.success) {
        this.successFullChanged = true
      } else {
        this.errors = res.errors
      }
    },
  },
}
</script>

<style scoped lang="scss">
.pw-reset {
  display: flex;
  justify-content: center;

  & > .box {
    max-width: 450px;
    width: 100%;
  }
}
</style>
